module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app_combobox_container",
    class: {
      to_top: _vm.isToTop
    },
    attrs: {
      "title": _vm.getText || _vm.placeholder
    }
  }, [_c('AppSvgIcon', {
    staticClass: "arrow_button",
    class: {
      arrow_button_transform: _vm.open
    },
    attrs: {
      "manual-height": "14px",
      "manual-width": "14px",
      "template": _vm.$ui.IconSvgComponents.arrowUp,
      "size": '100',
      "color-mode": 'hidden_fill'
    }
  }), (_vm.open) ? _c('div', {
    staticClass: "invisibleButton",
    on: {
      "click": function($event) {
        _vm.open = false
      }
    }
  }) : _vm._e(), _c('div', {
    ref: "combobox",
    staticClass: "combobox single",
    class: {
      disabled: _vm.disabled
    },
    style: (_vm.getStyle),
    attrs: {
      "tabindex": "-1",
      "id": _vm.id
    }
  }, [(_vm.open) ? _c('div', {
    staticClass: "data"
  }, [(_vm.filterable || _vm.filterable === "auto") ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    ref: _vm.thisInput,
    staticClass: "search",
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }) : _vm._e(), (_vm.getSelectedData.length) ? _c('div', {
    staticClass: "all_data"
  }, _vm._l((_vm.getSelectedData), function(data) {
    return _c('div', {
      key: data.id,
      staticClass: "selected_data",
      attrs: {
        "title": data.text
      },
      on: {
        "click": function($event) {
          return _vm.selectData(data)
        }
      }
    }, [_c('p', [_vm._v(_vm._s(data.text))])])
  }), 0) : _c('div', {
    staticClass: "nothing"
  }, [_c('div', {
    staticClass: "p"
  }, [_vm._v("Данные не найдены")])])]) : [_c('div', {
    staticClass: "selected",
    class: {
      placeholder: !_vm.selected
    },
    on: {
      "click": _vm.toggle
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.getText || _vm.placeholder))])])]], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16aa25f0","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppComboBox/AppComboboxSingle.vue
// module id = e9a62c0d738ce204c87e
// module chunks = 0